import { environment } from '../environments/environment';
import OktaAuth, { OktaAuthOptions } from '@okta/okta-auth-js';
import { requireSessionOwnership } from './core/navigation/auth/session-ownership';

// The post-logout redirect is region dependent and passed on sign-out (AuthFlowService)
export const oktaConfig: OktaAuthOptions = {
  clientId: environment.oktaOptions.clientId,
  issuer: environment.oktaOptions.issuerUri,
  redirectUri: environment.oktaOptions.redirectUri,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  tokenManager: {
    autoRenew: true
  },
  ignoreLifetime: true,
  // The SDK passes its core interface; the instance is the OktaAuth created in ShellCoreModule
  transformAuthState: (oktaAuth, authState) => requireSessionOwnership(oktaAuth as OktaAuth, authState)
};
